import React, { FunctionComponent } from 'react';
import { Image } from '@chakra-ui/react';
import { useFormContext } from '../../../../hooks';
import { CalculatorsStudentLoanResult } from '../../../../@types/features/calculators';
import { CalculatorStudentLoanSummary } from './calculator-student-loan-summary';
import useMediaQuery from '../../../../hooks/use-media';
import { mainMediaMobile } from '../../../../utils';
import { assetPrefix } from '../../../../utils';

export const CalculatorStudentLoanCta: FunctionComponent = () => {
  const { result } = useFormContext<CalculatorsStudentLoanResult>();
  const isMobile = useMediaQuery(mainMediaMobile);
  return (
    <div>
      <h2 className={`mb-0 md:mb-8`}>Hypotheek berekenen met een studieschuld</h2>
      {!result && (
        <div className={`hidden md:block`}>
          <div>
            In deze berekening gaan we uit van een annuïtaire hypotheek en gebruiken we de laagste
            rente op dit moment met rentevaste periode van 10 jaar. We houden alleen rekening met je
            inkomen en die van je eventuele partner en de studieschuld. Heb je nog andere financiële
            verplichtingen zoals een private lease auto of heb je ook een lopende hypotheek, dan kan
            je maximale hypotheek lager uitvallen. In onze uitgebreide maximale hypotheek berekening
            kan je verder rekenen.
          </div>
          <Image w={`364px`} src={`${assetPrefix}/assets/shared/images/cta.png`}></Image>
        </div>
      )}
      {result && !isMobile && (
        <CalculatorStudentLoanSummary result={result}></CalculatorStudentLoanSummary>
      )}
    </div>
  );
};
